export  default {
	yuantong:require("../images/expressicon/圆通.jpg"),
	shengtong:require("../images/expressicon/申通.jpg"),
	zhongtong:require("../images/expressicon/中通.jpg"),
	baishi:require("../images/expressicon/百世.jpg"),
	shunfeng:require("../images/expressicon/顺丰.jpg"),
	ems:require("../images/expressicon/EMS.jpg"),
	youzheng:require("../images/expressicon/邮政.jpg"),
	kuaijie:require("../images/expressicon/快捷.jpg"),
	jingdong:require("../images/expressicon/京东.jpg"),
	pinjun:require("../images/expressicon/唯品会.jpg"),
	guotong:require("../images/expressicon/国通.jpg"),
	tiantian:require("../images/expressicon/天天.jpg"),
	anneng:require("../images/expressicon/安能.jpg"),
	tmall:require("../images/expressicon/天猫.jpg"),
	deibang:require("../images/expressicon/德邦.jpg"),
	yousu:require("../images/expressicon/优速.jpg"),
	wanxiang:require("../images/expressicon/万象.jpg"),
	dongjun:require("../images/expressicon/东骏.jpg"),
	suning:require("../images/expressicon/苏宁.jpg"),
	yunda:require("../images/expressicon/韵达.jpg"),
	yamaxun:require("../images/expressicon/快递运输.png"),
	zhaojisong:require("../images/expressicon/快递运输.png"),
	lijisong:require("../images/expressicon/快递运输.png"),
	vip:require("../images/expressicon/快递运输.png"),
	quanf:require("../images/expressicon/快递运输.png"),
	tongcheng:require("../images/expressicon/快递运输.png"),
	suerkuaidi:require("../images/expressicon/快递运输.png"),
	wuliu:require("../images/expressicon/快递运输.png")
}